import { useEffect, useRef, useState } from "react";
import { PushpinFilled, PushpinOutlined, SendOutlined } from "@ant-design/icons";
import { formatarHoraChat } from "./chatFormat";
import { ChatEmojiPicker } from "./ChatEmojiPicker";
import { ChatFixadas } from "./ChatFixadas";
import { LIMITE_MENSAGEM_CHAT, inserirEmoji } from "./chatEmojis";

export const ChatThread = ({
  user,
  mensagens,
  fixadas,
  texto,
  enviando,
  onTexto,
  onEnviar,
  onFixar,
  onDesafixar,
}) => {
  const fimRef = useRef(null);
  const composerRef = useRef(null);
  const [emojiAberto, setEmojiAberto] = useState(false);
  const codigoUsuario = String(user?.codigo_usuario || "");
  const limiteFixadas = (fixadas || []).length >= 3;

  useEffect(() => {
    fimRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [mensagens]);

  useEffect(() => {
    if (!emojiAberto) return undefined;
    function fecharFora(evento) {
      if (!composerRef.current?.contains(evento.target)) {
        setEmojiAberto(false);
      }
    }
    document.addEventListener("mousedown", fecharFora);
    return () => document.removeEventListener("mousedown", fecharFora);
  }, [emojiAberto]);

  function tecla(evento) {
    if (evento.key === "Escape") {
      setEmojiAberto(false);
      return;
    }
    if (evento.key === "Enter" && !evento.shiftKey) {
      evento.preventDefault();
      enviar();
    }
  }

  function escolherEmoji(emoji) {
    onTexto(inserirEmoji(texto, emoji));
  }

  function enviar() {
    setEmojiAberto(false);
    onEnviar();
  }

  function irParaMensagem(codigo) {
    document
      .querySelector(`[data-chat-msg="${codigo}"]`)
      ?.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  return (
    <div className="chat-thread">
      <ChatFixadas
        mensagens={fixadas}
        onDesafixar={onDesafixar}
        onIrPara={irParaMensagem}
      />
      <div className="chat-mensagens">
        {(mensagens || []).map((mensagem) => {
          const propria = String(mensagem.autorCodigo) === codigoUsuario;
          const fixada = Boolean(mensagem.fixada);
          return (
            <div
              key={mensagem.codigo}
              data-chat-msg={mensagem.codigo}
              className={`chat-bolha ${
                propria ? "chat-bolha--propria" : "chat-bolha--outra"
              }${fixada ? " chat-bolha--fixada" : ""}`}
            >
              {mensagem.conteudo}
              <span className="chat-bolha__meta">
                <button
                  type="button"
                  className="chat-bolha__pin"
                  disabled={!fixada && limiteFixadas}
                  title={
                    fixada
                      ? "Desafixar"
                      : limiteFixadas
                      ? "Máximo de 3 mensagens fixadas"
                      : "Fixar no topo"
                  }
                  aria-label={fixada ? "Desafixar mensagem" : "Fixar mensagem"}
                  onClick={() =>
                    fixada ? onDesafixar(mensagem) : onFixar(mensagem)
                  }
                >
                  {fixada ? <PushpinFilled /> : <PushpinOutlined />}
                </button>
                <time>{formatarHoraChat(mensagem.dataCadastro)}</time>
              </span>
            </div>
          );
        })}
        <div ref={fimRef} />
      </div>
      <form
        ref={composerRef}
        className="chat-composer"
        onSubmit={(evento) => {
          evento.preventDefault();
          enviar();
        }}
      >
        <ChatEmojiPicker
          aberto={emojiAberto}
          onAlternar={() => setEmojiAberto((atual) => !atual)}
          onEscolher={escolherEmoji}
        />
        <textarea
          rows={1}
          maxLength={LIMITE_MENSAGEM_CHAT}
          placeholder="Mensagem"
          value={texto}
          onChange={(evento) => onTexto(evento.target.value)}
          onKeyDown={tecla}
        />
        <button
          type="submit"
          className="chat-composer__enviar"
          disabled={enviando || !texto?.trim()}
          aria-label="Enviar"
        >
          <SendOutlined />
        </button>
      </form>
    </div>
  );
};
